/** Static payment-outcome page. Repayments confirm in-app via the intent
 * status poll; this route survives only for old links and redirects home. */
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export function PaymentSuccess() {
  return (
    <div className="premium-page flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-4 py-10 text-center">
          <CheckCircle2 className="h-10 w-10 text-success" />
          <div>
            <h1 className="text-xl font-semibold">Payment received</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Your balance updates as soon as the provider confirms — check My Loans.
            </p>
          </div>
          <Button asChild><Link to="/dashboard/loans">Go to My Loans</Link></Button>
        </CardContent>
      </Card>
    </div>
  );
}
